/**
 * @file pictureタグ polyfill
 */

import 'picturefill';
